document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".hotspot-slider");
  if (!section) return;

  const buttons = section.querySelectorAll(".hotspot-btn");
  const slides = section.querySelectorAll(".hotspot-slide");
  let activeIndex = 0;

  function keepLabelsInsideImage() {
    const image = section.querySelector(".hotspot-slider__image");
    if (!image) return;

    const imageRect = image.getBoundingClientRect();
    const edgeGap = 16;
    const dotGap = 16;

    function getAllowedShift(label, labelRect, dotRect) {
      let minShift = imageRect.left + edgeGap - labelRect.left;
      let maxShift = imageRect.right - edgeGap - labelRect.right;
      const labelOnLeft = label.classList.contains("hotspot-label--left") !==
        label.classList.contains("is-flipped");

      if (labelOnLeft) {
        maxShift = Math.min(
          maxShift,
          dotRect.left - dotGap - labelRect.right
        );
      } else {
        minShift = Math.max(
          minShift,
          dotRect.right + dotGap - labelRect.left
        );
      }

      return { minShift, maxShift };
    }

    buttons.forEach((button) => {
      const label = button.querySelector(".hotspot-btn__label");
      const dot = button.querySelector(".hotspot-btn__dot");
      if (!label || !dot) return;

      // Reset before measuring so resize/reflow corrections do not accumulate.
      label.classList.remove("is-flipped");
      label.style.setProperty("--label-shift-x", "0px");

      let labelRect = label.getBoundingClientRect();
      const dotRect = dot.getBoundingClientRect();
      let { minShift, maxShift } = getAllowedShift(label, labelRect, dotRect);

      // If the label cannot fit between the image edge and the dot, use the
      // other side of the dot before applying the edge correction.
      if (minShift > maxShift) {
        label.classList.add("is-flipped");
        labelRect = label.getBoundingClientRect();
        ({ minShift, maxShift } = getAllowedShift(label, labelRect, dotRect));
      }

      const shift = Math.min(Math.max(0, minShift), maxShift);

      label.style.setProperty("--label-shift-x", `${shift}px`);
    });
  }

  requestAnimationFrame(keepLabelsInsideImage);
  window.addEventListener("resize", keepLabelsInsideImage);

  section.querySelectorAll(".hotspot-slider__image img").forEach((image) => {
    image.addEventListener("load", keepLabelsInsideImage);
  });

  if (window.ResizeObserver) {
    const imageObserver = new ResizeObserver(keepLabelsInsideImage);
    const imageContainer = section.querySelector(".hotspot-slider__image");
    if (imageContainer) imageObserver.observe(imageContainer);
  }

  function showSlide(index) {
    slides.forEach((s, i) => s.classList.toggle("active", i === index));
    activeIndex = index;
  }

  buttons.forEach((btn, i) => {
    btn.addEventListener("click", () => showSlide(i));
  });

  const next = section.querySelector(".next");
  const prev = section.querySelector(".prev");

  if (next && prev) {
    next.addEventListener("click", () => showSlide((activeIndex + 1) % slides.length));
    prev.addEventListener("click", () => showSlide((activeIndex - 1 + slides.length) % slides.length));
  }
});

/* -----------------------------------
   2. MOBILE MODAL LOGIC
------------------------------------ */
document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("hotspotMobileModal");
  if (!modal) return;

  const modalImage = modal.querySelector(".hotspot-mobile__image");
  const modalContent = modal.querySelector(".hotspot-mobile__content");

  const closeBtn = modal.querySelector(".hotspot-mobile__close");
  const prevBtn = modal.querySelector(".hotspot-mobile-prev");
  const nextBtn = modal.querySelector(".hotspot-mobile-next");
  const inner = modal.querySelector(".hotspot-mobile__inner");

  const slides = document.querySelectorAll(".hotspot-slide");
  let currentIndex = 0;
  let closeToneRequest = 0;

  // Resolve the real, full-size image for a slide instead of the lazyload
  // placeholder: prefer the already-resolved srcset/currentSrc (set once
  // lazysizes has loaded the slide), falling back to the data-srcset the
  // snippet renders before lazysizes has had a chance to run.
  function resolveSlideImageSource(source) {
    const srcset = (source.srcset && source.srcset.trim())
      ? source.srcset
      : source.getAttribute("data-srcset");
    const sizes = (source.sizes && source.sizes.trim() && source.sizes !== "auto")
      ? source.sizes
      : (source.getAttribute("data-sizes") === "auto" ? "100vw" : source.getAttribute("data-sizes"));
    const isPlaceholder = source.classList.contains("lazyload") && !source.classList.contains("lazyloaded");
    const fallbackSrc = isPlaceholder ? null : (source.currentSrc || source.src);

    return { srcset, sizes, fallbackSrc, alt: source.alt };
  }

  // Cache of preloaded <img> elements per slide index so switching slides
  // never re-fetches or re-decodes an image that was already shown.
  const slideImageCache = new Map();

  function getCachedSlideImage(index) {
    if (slideImageCache.has(index)) return slideImageCache.get(index);

    const slide = slides[index];
    const source = slide.querySelector(".hotspot-slide__image img");
    if (!source) return null;

    const { srcset, sizes, fallbackSrc, alt } = resolveSlideImageSource(source);

    const image = new Image();
    image.alt = alt || "";
    image.loading = "eager";
    image.decoding = "async";
    if (sizes) image.sizes = sizes;
    if (srcset) {
      image.srcset = srcset;
    } else if (fallbackSrc) {
      image.src = fallbackSrc;
    }

    slideImageCache.set(index, image);
    return image;
  }

  function preloadSlideImages() {
    slides.forEach((_, index) => getCachedSlideImage(index));
  }

  preloadSlideImages();

  function setCloseButtonTone(isOnDark) {
    closeBtn.classList.toggle("is-on-dark", isOnDark);
  }

  function sampleImageBrightness(image) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d", { willReadFrequently: true });

    if (!context || !image.naturalWidth || !image.naturalHeight) return null;

    const sampleWidth = Math.max(1, Math.round(image.naturalWidth * 0.22));
    const sampleHeight = Math.max(1, Math.round(image.naturalHeight * 0.18));
    const startX = Math.max(0, image.naturalWidth - sampleWidth);
    const startY = 0;

    canvas.width = sampleWidth;
    canvas.height = sampleHeight;

    try {
      context.drawImage(
        image,
        startX,
        startY,
        sampleWidth,
        sampleHeight,
        0,
        0,
        sampleWidth,
        sampleHeight
      );
    } catch (error) {
      return null;
    }

    const { data } = context.getImageData(0, 0, sampleWidth, sampleHeight);
    let totalLuminance = 0;
    let pixelCount = 0;

    for (let index = 0; index < data.length; index += 4) {
      const alpha = data[index + 3];

      if (!alpha) continue;

      const red = data[index];
      const green = data[index + 1];
      const blue = data[index + 2];

      totalLuminance += 0.2126 * red + 0.7152 * green + 0.0722 * blue;
      pixelCount += 1;
    }

    if (!pixelCount) return null;

    return totalLuminance / pixelCount;
  }

  function updateCloseButtonContrast() {
    const requestId = ++closeToneRequest;
    const image = modalImage.querySelector("img");

    setCloseButtonTone(false);

    if (!image) return;

    const applyTone = () => {
      if (requestId !== closeToneRequest) return;

      const brightness = sampleImageBrightness(image);

      if (brightness === null) return;

      setCloseButtonTone(brightness < 135);
    };

    if (image.complete && image.naturalWidth) {
      applyTone();
      return;
    }

    image.addEventListener("load", applyTone, { once: true });
    image.addEventListener("error", () => {
      if (requestId !== closeToneRequest) return;
      setCloseButtonTone(false);
    }, { once: true });
  }

  function renderMobileSlide(index) {
    const slide = slides[index];

    modalContent.innerHTML = slide.querySelector(".hotspot-slide__content").innerHTML;

    // Build the modal image from the preloaded/cached full-size image
    // instead of cloning the slide's <img>, which may still be the
    // lazyload placeholder if that slide has never scrolled into view.
    modalImage.innerHTML = "";
    const cached = getCachedSlideImage(index);
    if (cached) modalImage.appendChild(cached);

    inner.style.background = slide.style.getPropertyValue("--color");
    updateCloseButtonContrast();
  }

  function revealMobileSlideWhenReady(index) {
    const image = getCachedSlideImage(index);
    const reveal = () => {
      requestAnimationFrame(() => {
        inner.classList.add("is-visible");
      });
    };

    if (!image) {
      reveal();
      return;
    }

    if (image.complete && image.naturalWidth) {
      if (image.decode) {
        image.decode().catch(() => {}).finally(reveal);
      } else {
        reveal();
      }
      return;
    }

    image.addEventListener("load", reveal, { once: true });
    image.addEventListener("error", reveal, { once: true });
  }

  function openMobileModal(index) {
    currentIndex = index;

    // Hide the sticky header immediately so it cannot cover the modal image.
    document.body.classList.add("hotspot-modal-open");
    document.body.style.overflow = "hidden";

    renderMobileSlide(index);
    modal.style.display = "flex";
    revealMobileSlideWhenReady(index);
  }

  function closeMobileModal() {
    inner.classList.remove("is-visible");
    closeToneRequest += 1;
    setCloseButtonTone(false);

    setTimeout(() => {
      modal.style.display = "none";
      document.body.classList.remove("hotspot-modal-open");
      document.body.style.overflow = "";
    }, 200);
  }

  function showMobileSlide(direction) {
    inner.classList.remove("is-visible");

    setTimeout(() => {
      currentIndex = (currentIndex + direction + slides.length) % slides.length;
      renderMobileSlide(currentIndex);
      revealMobileSlideWhenReady(currentIndex);
    }, 150);
  }

  document.querySelectorAll(".hotspot-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      if (window.innerWidth <= 768) {
        const index = parseInt(btn.dataset.index);
        openMobileModal(index);
      }
    });
  });

  closeBtn.addEventListener("click", closeMobileModal);
  prevBtn.addEventListener("click", () => showMobileSlide(-1));
  nextBtn.addEventListener("click", () => showMobileSlide(1));
});
